var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CardPaymentSummaryLocation_1;
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Card, CollapseArrow, Image, Map, Text } from '@philips-internal/oswald-ui-components/lib/components';
import React, { Component } from 'react';
import './card-payment-summary-location.css';
import LocaleSVG from '../../assets/images/global/locale.svg';
import PhoneSVG from '../../assets/images/icons/Phone.svg';
import { isMobileResolution } from '@philips-internal/oswald-ui-utils';
let CardPaymentSummaryLocation = class CardPaymentSummaryLocation extends Component {
    constructor() {
        super(...arguments);
        this.state = { open: true };
    }
    static { CardPaymentSummaryLocation_1 = this; }
    static { this.propTypes = { className: string, uuid: string, width: number }; }
    static { this.defaultProps = { width: 12 }; }
    collapseEstablishment() {
        this.setState({
            open: !this.state.open
        });
    }
    render() {
        const { uuid, className, width = CardPaymentSummaryLocation_1.defaultProps.width, establishmentDescription, phone, address, mapLink } = this.props;
        let collapsedEstablishment = '';
        let collapsedEstablishmentAction = '';
        if (isMobileResolution()) {
            collapsedEstablishmentAction = this.state.open ? 'collapsed-establishment-open' : 'collapsed-establishment-close';
        }
        else {
            collapsedEstablishment = 'collapse-establishment';
        }
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.SINGLE, width: width, className: className },
            React.createElement("div", { className: "establishment-info" },
                React.createElement("h3", { className: "establishment-name", onClick: () => this.collapseEstablishment() },
                    React.createElement(Text, { value: establishmentDescription }),
                    React.createElement(CollapseArrow, { className: collapsedEstablishment, collapsed: this.state.open })),
                React.createElement("div", { className: 'location-content' + ' ' + `${collapsedEstablishmentAction}` },
                    React.createElement("div", { className: 'establishment-location' },
                        React.createElement("div", { className: "phone text-icon-wrapper" },
                            React.createElement("span", null,
                                React.createElement(Image, { src: PhoneSVG, className: 'info-icon', alt: '' })),
                            React.createElement("span", { className: "establishment-phone" },
                                React.createElement(Text, { value: ` + ${phone}` }))),
                        React.createElement("div", { className: "address text-icon-wrapper" },
                            React.createElement("span", null,
                                React.createElement(Image, { src: LocaleSVG, className: 'info-icon', alt: '' })),
                            React.createElement("span", { className: "establishment-address" },
                                React.createElement(Text, { value: address })))),
                    React.createElement("div", { className: "detail-area establishment-map" },
                        React.createElement(Map, { providerUrl: `https://www.google.com/maps/embed/v1/place?q=${mapLink}` }))))));
    }
};
CardPaymentSummaryLocation = CardPaymentSummaryLocation_1 = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardPaymentSummaryLocation);
export default CardPaymentSummaryLocation;
//# sourceMappingURL=card-payment-summary-location.js.map